import React from "react";
import {ColumnsType} from "antd/es/table";
import {FIELD_TYPE, FORMAT_TIME, TT_PHIEU_KHO} from "types/enums";
import {ColumnProps} from "types/models";
import {
  convertIosStringToDate,
  formatDateToString,
  formatToCurrencyType,
} from "helper/common";
import {listTTPhieuKho} from "data/list";

const {INPUT, SELECT, DATE, COMBO_BOX} = FIELD_TYPE;

const allColumns: ColumnProps[] = [
  {
    key: "index",
    title: "STT",
    show: true,
    isResizable: true,
    dataIndex: "index",
    render(value, record, index) {
      return <>{index + 1}</>;
    },
    align: "center",
  },
  {
    key: "code",
    title: "Mã phiếu",
    align: "center",
    show: true,
    isResizable: true,
    dataIndex: "id",
  },
  {
    key: "tieuDe",
    title: "Tiêu đề",
    width: 90,
    show: true,
    isResizable: true,
    dataIndex: "tieuDe",
    align: "left",
  },
  {
    title: "Kho nhập",
    key: "khoNhap",
    show: true,
    isResizable: true,
    dataIndex: "khoNhap",
  },
  {
    title: "Kho xuất",
    key: "khoXuat",
    show: true,
    isResizable: true,
    dataIndex: "khoXuat",
  },
  {
    title: "Tiêu đề phiếu",
    key: "tieuDe",
    show: true,
    isResizable: true,
    dataIndex: "tieuDe",
  },
  {
    title: "Nguồn thuốc",
    key: "nguonThuoc",
    show: true,
    isResizable: true,
    dataIndex: "nguonThuoc",
  },
  {
    title: "Trạng thái phiếu",
    key: "tinhTrang",
    show: true,
    isResizable: true,
    dataIndex: "tinhTrang",
    render(value, record, index) {
      var tinhTrang;
      switch (value) {
        case TT_PHIEU_KHO.NHAP:
          return "Nháp";
        case TT_PHIEU_KHO.CHO_DUYET:
          return "Chờ duyệt";
        case TT_PHIEU_KHO.DA_DUYET:
          return "Đã duyệt";
        case TT_PHIEU_KHO.HOAN_THANH:
          return "Hoàn thành";
        case TT_PHIEU_KHO.HUY_PHIEU:
          return "Hủy";
        case TT_PHIEU_KHO.TU_CHOI:
          return "Từ chối";
        default:
          break;
      }
    },
  },
  {
    title: "Ngày lập phiếu",
    key: "createDate",
    show: true,
    isResizable: true,
    align: "center",
    dataIndex: "createDate",
    render(value, record, index) {
      return (
        <>{value ? formatDateToString(value, FORMAT_TIME.dateTime) : null}</>
      );
    },
  },
  {
    title: "Ngày hoàn thành xuất",
    key: "ngayHoanThanh",
    show: true,
    isResizable: true,
    align: "center",
    dataIndex: "ngayHoanThanh",
    render(value, record, index) {
      return (
        <>{value ? formatDateToString(value, FORMAT_TIME.dateTime) : null}</>
      );
    },
  },
  {
    title: "Người lập phiếu",
    key: "nguoiLap",
    show: true,
    isResizable: true,
    dataIndex: "nguoiLap",
  },
  {
    title: "Người giao",
    key: "nguoiGiao",
    show: true,
    isResizable: true,
    dataIndex: "nguoiGiao",
  },
  {
    title: "Người nhận",
    key: "nguoiNhan",
    show: true,
    isResizable: true,
    dataIndex: "nguoiNhan",
  },
  {
    title: "Người dự trù",
    key: "nguoiDuTru",
    show: false,
    isResizable: true,
    dataIndex: "nguoiDuTru",
  },
  {
    title: "Tổng giá trị (VNĐ)",
    key: "tongGiaTri",
    show: true,
    isResizable: true,
    dataIndex: "tongGiaTri",
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Ghi chú",
    key: "ghiChu",
    show: true,
    isResizable: true,
    dataIndex: "ghiChu",
  },
  {
    title: "Mã phiếu tham chiếu",
    key: "phieuThamChieuId",
    show: true,
    isResizable: true,
    align: "center",
    dataIndex: "phieuThamChieuId",
  },
];

const inputFields: any[] = [
  {
    type: INPUT,
    name: "id",
    label: "Mã phiếu",
  },
  {
    type: INPUT,
    name: "tieu-de",
    label: "Tiêu đề phiếu",
  },
  {
    type: COMBO_BOX,
    name: "kho-nhap-id",
    label: "Kho nhập",
  },
  {
    type: COMBO_BOX,
    name: "kho-xuat-id",
    label: "Kho xuất",
  },
  // {
  //   type: COMBO_BOX,
  //   name: "loa-phieu",
  //   label: "Danh mục",
  // },
  // {
  //   type: COMBO_BOX,
  //   label: "Tên nhóm",
  // },
  {
    type: COMBO_BOX,
    name: "tinh-trang",
    label: "Tình trạng",
    options: listTTPhieuKho,
  },
  {
    type: DATE,
    name: "start",
    label: "Từ ngày",
  },
  {
    type: DATE,
    name: "end",
    label: "Đến ngày",
  },
];

export {allColumns, inputFields};
